interface IProps {
  className?: string;
}

export const MarketScanInProgressIcon = ({ className }: IProps) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.1296 6V9.77778H13.8704V6H15.1296Z"
        fill="#14181F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.96373 8.0733L11.4823 10.5918L10.5918 11.4823L8.0733 8.96373L8.96373 8.0733Z"
        fill="#14181F"
      />
      <path
        opacity="0.9"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 13.8704H9.77778V15.1296H6V13.8704Z"
        fill="#14181F"
      />
      <path
        opacity="0.75"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.0733 20.0363L10.5918 17.5177L11.4823 18.4082L8.96373 20.9267L8.0733 20.0363Z"
        fill="#14181F"
      />
      <path
        opacity="0.6"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.8704 23V19.2222H15.1296V23H13.8704Z"
        fill="#14181F"
      />
      <path
        opacity="0.45"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.0362 20.9267L17.5177 18.4082L18.4081 17.5177L20.9267 20.0363L20.0362 20.9267Z"
        fill="#14181F"
      />
      <path
        opacity="0.3"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23 15.1296H19.2222V13.8704H23V15.1296Z"
        fill="#14181F"
      />
      <path
        opacity="0.15"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.9267 8.96373L18.4081 11.4823L17.5177 10.5918L20.0362 8.0733L20.9267 8.96373Z"
        fill="#14181F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5 5C9.25329 5 5 9.25329 5 14.5C5 19.7467 9.25329 24 14.5 24C19.7467 24 24 19.7467 24 14.5C24 9.25329 19.7467 5 14.5 5ZM3 14.5C3 8.14873 8.14873 3 14.5 3C20.8513 3 26 8.14873 26 14.5C26 17.3156 24.9881 19.8949 23.3082 21.894L29.7071 28.2929L28.2929 29.7071L21.894 23.3082C19.8949 24.9881 17.3156 26 14.5 26C8.14873 26 3 20.8513 3 14.5Z"
        fill="#14181F"
      />
    </svg>
  );
};
